import axios from "axios";
import { get } from "lodash";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  REQUEST_MASTER_SLOTS,
  REQUEST_CREATE_MASTER_SLOTS,
  SET_MASTER_SLOTS,
  SUCCESS_CREATE_MASTER_SLOTS,
  ERROR_GET_MASTER_SLOTS,
  ERROR_CREATE_MASTER_SLOTS,
  SUCCESS_DELETE_MASTER_SLOTS,
  SUCCESS_UPDATE_MASTER_SLOTS,
  REQUEST_DELETE_MASTER_SLOTS,
  REQUEST_UPDATE_MASTER_SLOTS,
  ERROR_DELETE_MASTER_SLOTS,
  ERROR_UPDATE_MASTER_SLOTS,
  REQUEST_CREATE_GET_MASTER_SLOTS,
  ERROR_CREATE_GET_MASTER_SLOTS,
  SUCCESS_CREATE_GET_MASTER_SLOTS,
} from "./slotsActionTypes";

function* requestMasterSlots(action: Record<string, any>): any {
  try {
    const result: any = yield call(getSlotsMaster);
    yield put({ type: SET_MASTER_SLOTS, payload: result.data.data });
    // console.warn(result.data.data, "jhuihihi");
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_GET_MASTER_SLOTS, payload: message });
  }
}

function* requestUpdateMasterTagSlots(action: Record<string, any>): any {
  try {
    const result = yield call(
      updateMasterSlots,
      action.data.payload
      // action.data._id
    );
    yield put({
      type: SUCCESS_UPDATE_MASTER_SLOTS,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
    console.log(result.data, "result.data.dataupdate");
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_UPDATE_MASTER_SLOTS, payload: message });
  }
}

function* requestDeleteMasterTagSlots(action: Record<string, any>): any {
  // try {
  //   yield call(
  //     deleteMasterSlots,
  //     get(action, "payload._id", ""),
  //     get(action, "payload.restaurantId", "")
  //   );
  //   yield put({
  //     type: SUCCESS_DELETE_MASTER_SLOTS,
  //     payload: get(action, "payload._id", ""),
  //   });
  // } catch (error: any) {
  try {
    const _id = get(action, "payload._id", "");
    const restaurantId = get(action, "payload.restaurantId", "");
    const type = get(action, "payload.type", "");
    yield call(deleteMasterSlots, _id, restaurantId, type);
    yield put({
      type: SUCCESS_DELETE_MASTER_SLOTS,
      payload: { _id, restaurantId, type },
    });
    if (action.onSuccess) {
      yield call(action.onSuccess);
    }
    // console.log("deleteMasterTagSlots", _id, restaurantId, type);
  } catch (error: any) {
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_DELETE_MASTER_SLOTS, payload: message });
  }
}

function* requestCreateMasterSlots(action: Record<string, any>): any {
  try {
    const result = yield call(createMasterSlots, action.payload);

    yield put({
      type: SUCCESS_CREATE_MASTER_SLOTS,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
    console.log(result.data, "result.data.datacreate");

    // update relevant category as well
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_CREATE_MASTER_SLOTS, payload: message });
  }
}

function* requestCreateGetMasterSlots(action: Record<string, any>): any {
  try {
    const result = yield call(createGetMasterSlots, action.payload);

    yield put({
      type: SUCCESS_CREATE_GET_MASTER_SLOTS,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
    console.log(result.data, "result.data.datacreateget");

    // create relevant category as well
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_CREATE_GET_MASTER_SLOTS, payload: message });
  }
}

export function getSlotsMaster() {
  return axios({
    method: "GET",
    url: `${process.env.REACT_APP_BASE_URL}/slot`,
    withCredentials: true,
  });
}

export function createMasterSlots(payload: Record<string, any>) {
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/admin/slot`,
    data: payload,
    withCredentials: true,
  });
}
export function createGetMasterSlots(payload: Record<string, any>) {
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/admin/slot/getSlot`,
    data: payload,
    withCredentials: true,
  });
}

export function deleteMasterSlots(
  _id: string,
  restaurantId: string,
  type: string
) {
  return axios({
    method: "delete",
    url: `${process.env.REACT_APP_BASE_URL}/admin/slot?slotId=${_id}&restaurantId=${restaurantId}&type=${type}`,
    withCredentials: true,
  });
}
export function updateMasterSlots(payload: Record<string, any>) {
  console.log("payload niraliiiiiiiiiiii", payload);

  return axios({
    method: "patch",
    url: `${process.env.REACT_APP_BASE_URL}/admin/slot`,
    data: payload,
    withCredentials: true,
  });
}

const slotsMasterSaga = function* () {
  yield all([
    takeLatest(REQUEST_MASTER_SLOTS, requestMasterSlots),
    takeLatest(REQUEST_CREATE_MASTER_SLOTS, requestCreateMasterSlots),
    takeLatest(REQUEST_CREATE_GET_MASTER_SLOTS, requestCreateGetMasterSlots),
    takeLatest(REQUEST_UPDATE_MASTER_SLOTS, requestUpdateMasterTagSlots),
    takeLatest(REQUEST_DELETE_MASTER_SLOTS, requestDeleteMasterTagSlots),
  ]);
};

export default slotsMasterSaga;
